import { render, staticRenderFns } from "./PlaceServices.vue?vue&type=template&id=a4943e52&"
import script from "./PlaceServices.vue?vue&type=script&lang=js&"
export * from "./PlaceServices.vue?vue&type=script&lang=js&"
import style0 from "./PlaceServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports